<mat-sidenav-container class="h-full">
  <mat-sidenav fixedInViewport opened="true" mode="side" disableClose>
    <div class="h-full flex flex-col">
      <mat-toolbar class="bg-transparent shrink-0">
        <div class="size-10">
          <img src="icon.svg" class="size-full select-none" draggable="false" alt="" />
        </div>
      </mat-toolbar>

      <div class="flex-auto overflow-auto scrollbar-width-thin">
        @if (!onboardingPending()) {
          <app-sidenav-menu />
        }
      </div>
    </div>
  </mat-sidenav>

  <mat-sidenav-content class="bg-gray-100 !flex flex-col">
    <app-header>
      @if (currentUnit(); as unit) {
        <div class="flex items-center">
          @if (!onboardingPending()) {
          <button *appHasPermission="'unit:read'" mat-icon-button matTooltip="Bekijk alle units" routerLink="/units">
            <mat-icon class="size-4.5! text-lg/4.5! font-medium!">deployed_code</mat-icon>
          </button>
          }
          <span
            class="truncate max-w-30 text-base font-medium text-gray-800"
            [matTooltip]="unit.name"
            >{{ unit.name }}</span
          >
        </div>
      }
    </app-header>

    @if (isViewingOtherUnit()) {
      <div
        class="flex items-center justify-between gap-3 px-4 py-2 bg-amber-50 border-b border-amber-200 shrink-0"
      >
        <div class="flex items-center gap-2 min-w-0">
          <mat-icon class="text-amber-600 !text-lg flex-none">swap_horiz</mat-icon>
          <span class="text-sm font-medium text-amber-800 truncate">
            Je bekijkt een andere unit: <strong>{{ currentUnit()?.name }}</strong>
          </span>
        </div>
        <button
          mat-button
          class="shrink-0 !text-amber-700 !bg-amber-100 hover:!bg-amber-200"
          (click)="returnToHomeUnit()"
        >
          <mat-icon>home</mat-icon>
          Terug naar eigen unit
        </button>
      </div>
    }

    <div class="flex-auto overflow-auto scrollbar-width-thin">
      <router-outlet />
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
